module.exports = __webpack_public_path__ + "static/media/cover.d2e8a6ce.webp";